
  import Vue from 'vue';
  import {mapState, mapMutations} from 'vuex';
  import * as VuexMutation from '@/store/mutation-types';

  export default Vue.extend({
    name: 'DataManager',
    computed: {
      ...mapState(['messages']),
    },
    methods: {
      ...mapMutations({
        removeMessage: VuexMutation.REMOVE_MESSAGE,
      }),
    },
  });
